"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportAsCsv = void 0;
const CsvFile_1 = require("@juvare/data-import-ui/CsvFile");
const getIdsForAction_1 = require("./getIdsForAction");
function exportAsCsv(props, storage, selectedRowIds, filterData, sortColumnKey, sortColumnDesc, all) {
    return __awaiter(this, void 0, void 0, function* () {
        if (props.csvFileHeader && props.mapDataToCsvRow) {
            const csvFile = {
                header: props.csvFileHeader,
                rows: [],
            };
            const ids = yield (0, getIdsForAction_1.getIdsForAction)(props, storage, selectedRowIds, filterData, sortColumnKey, sortColumnDesc, all);
            for (const id of ids) {
                const response = yield storage.get(id);
                csvFile.rows.push(yield props.mapDataToCsvRow(response));
            }
            return (0, CsvFile_1.stringifyCsvFileToDataUrl)(csvFile);
        }
        else {
            return '';
        }
    });
}
exports.exportAsCsv = exportAsCsv;
